/** URL parameters working tools */

/** URL parameters object */
const urlParams = new URLSearchParams(window.location.search);

/**
 * Return map with [key]: [value], where:
 *  key - query parameter name
 *  value - array of values
 */
export const getAllUrlParams = () => {
  const params = {};

  for (const pair of urlParams.entries()) {
    const key = pair[0];
    const value = pair[1];

    if (!params[key]) {
      params[key] = [];
    }

    params[key].push(value);
  }

  return params;
};

/**
 * Return array of values for query parameter name
 * @param {String} key Query parameter name
 */
export const getUrlParamsByKey = key => {
  return urlParams.getAll(key);
};

/**
 * Add new (or update old) query parameter value in URL
 * If there was several values for key, then all other will be reset
 * @param {String} key Query parameter name
 * @param {String} value New query parameter value
 */
export const setUrlParam = (key, value) => {
  urlParams.set(key, value);
  updateURL();
};

/**
 * Remove query parameter from URL
 * @param {String} key Query parameter name
 */
export const deleteUrlParam = key => {
  urlParams.delete(key);
  updateURL();
};

/**
 * Update browser URL string with changes in urlParams
 */
function updateURL() {
  let queryString = "";

  if (urlParams.toString()) {
    queryString = "?" + urlParams.toString();
  }

  /** short name for url line */
  const loc = window.location;
  var newUrl = `${loc.protocol}//${loc.host}${loc.pathname}${queryString}`;
  window.history.pushState({}, document.title, newUrl);
}
